import {
  AppTheme,
  LANGUAGE,
  USERSROLE,
  AUTH_TYPE,
  MapSearchLocationHistory
} from 'types';

export interface ActionTypes {
  INIT_APP_LOADING: string;
  INIT_APP_SUCCESS: string;
  INIT_APP_FAILURE: string;
  SET_APP_THEME: string;
  SET_APP_LANGUAGE: string;
  SET_APP_USER_ROLE: string;
  SET_APP_AUTH_TYPE: string;
  SET_MAP_SEARCH_LOCATION_HISTORY: string;
  SET_APP_INITIAL_STATE: string;
  SET_HEADER_PANEL_EXPAND: string;
  RESET_APP_AUTH_STATE_START: string;
  RESET_APP_AUTH_STATE_FINISH: string;
  SET_BASE_MAP: string;
  RESET_SSO_COMPLETE: string;
  SET_APP_VISIBLE_PANEL: string;
  SET_SHOW_CLO_LISTING: string;
  SET_SHOW_INTERSTITIAL_PAGE: string;
}

export const AppActionTypes: ActionTypes = {
  INIT_APP_LOADING: '@@INIT_APP_LOADING',
  INIT_APP_SUCCESS: '@@INIT_APP_SUCCESS',
  INIT_APP_FAILURE: '@@INIT_APP_FAILURE',
  SET_APP_THEME: '@@SET_APP_THEME',
  SET_APP_LANGUAGE: '@@SET_APP_LANGUAGE',
  SET_APP_USER_ROLE: '@@SET_APP_USER_ROLE',
  SET_APP_AUTH_TYPE: '@@SET_APP_AUTH_TYPE',
  SET_MAP_SEARCH_LOCATION_HISTORY: '@@SET_MAP_SEARCH_LOCATION_HISTORY',
  SET_APP_INITIAL_STATE: '@@SET_APP_INITIAL_STATE',
  SET_HEADER_PANEL_EXPAND: '@@SET_HEADER_PANEL_EXPAND',
  RESET_APP_AUTH_STATE_START: '@@RESET_APP_AUTH_STATE_START',
  RESET_APP_AUTH_STATE_FINISH: '@@RESET_APP_AUTH_STATE_FINISH',
  SET_BASE_MAP: '@@SET_BASE_MAP',
  RESET_SSO_COMPLETE: '@@RESET_SSO_COMPLETE',
  SET_APP_VISIBLE_PANEL: '@@SET_APP_VISIBLE_PANEL',
  SET_SHOW_CLO_LISTING: '@@SET_SHOW_CLO_LISTING',
  SET_SHOW_INTERSTITIAL_PAGE: '@@SET_SHOW_INTERSTITIAL_PAGE'
};

export interface AppState {
  loading: boolean;
  theme?: AppTheme;
  language?: LANGUAGE;
  userRole?: USERSROLE;
  loginType?: AUTH_TYPE | null;
  mapSearchLocationHistory?: MapSearchLocationHistory;
  selectedBasemap: string;
  baseMapTheme?: string;
  headerPanelExpand?: any;
  error?: string;
  isSignOutLoading?: boolean;
  appVisiblePanel?: string;
  showCLOListing?: Array<any>;
  showInterstitialPage?: boolean;
}

export default AppActionTypes;
